import {
    START_LOAD_RESOURCE,
    FINISH_LOAD_RESOURCE,
    SET_RESOURCE,
} from './actionTypes';

export const resourceLoadStart = (
    cacheId,
    resourceId,
    getResourcePromise,
    testValidity,
    resolve,
    reject,
) => ({
    type: START_LOAD_RESOURCE,
    cacheId,
    resourceId,
    getResourcePromise,
    testValidity,
    resolve,
    reject,
});

export const resourceLoadSuccess = (cacheId, resourceId, payload) => ({
    type: FINISH_LOAD_RESOURCE,
    cacheId,
    resourceId,
    payload,
});

export const resourceLoadFailure = (
    cacheId,
    resourceId,
    error,
    errorDetail,
) => ({
    type: FINISH_LOAD_RESOURCE,
    cacheId,
    resourceId,
    error,
    errorDetail,
});

export const resourceSet = (cacheId, resourceId, resource) => ({
    type: SET_RESOURCE,
    cacheId,
    resourceId,
    resource,
});

export const resourceUpdate = (cacheId, resourceId, payload) =>
    resourceSet(cacheId, resourceId, {
        timestamp: Date.now(),
        payload,
    });

export const resourceInvalidate = (cacheId, resourceId) =>
    resourceSet(cacheId, resourceId, {
        invalid: true,
    });
